(() => {
  const HOST_SELECTOR = 'form-embed, shopify-forms-embed';
  const OVERLAY_SELECTOR = '[class*="_overlay_"]';
  const CARD_SELECTOR = '[class*="_overlay_"] > [class*="_formContainer_"]';
  const BACKDROP_SELECTOR = '[class*="_overlayBackground_"]';
  const CLOSE_SELECTOR = '[class*="_formCloseButton_"]';
  const EXIT_MS = 200;
  const EXIT_EASING = 'cubic-bezier(0.23, 1, 0.32, 1)';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bound = new WeakSet();
  const closing = new WeakSet();

  function closeTarget(event) {
    const target = event.target;
    if (!(target instanceof Element)) return null;
    const close = target.closest(CLOSE_SELECTOR);
    if (close && close.closest(CARD_SELECTOR)) return close;
    if (target.matches(BACKDROP_SELECTOR) || target.matches(OVERLAY_SELECTOR)) return target;
    return null;
  }

  function animateOut(root) {
    const card = root.querySelector(CARD_SELECTOR);
    const backdrop = root.querySelector(BACKDROP_SELECTOR);
    const options = { duration: EXIT_MS, easing: EXIT_EASING, fill: 'forwards' };
    const cardTo = reducedMotion.matches ? 'none' : 'translateY(12px) scale(0.98)';
    const animations = [
      card?.animate([{ opacity: 0, transform: cardTo }], options),
      backdrop?.animate([{ opacity: 0 }], options),
    ].filter(Boolean);
    return Promise.all(animations.map((animation) => animation.finished.catch(() => null)));
  }

  function bind(host) {
    const root = host.shadowRoot;
    if (!root || bound.has(host)) return;
    bound.add(host);
    root.addEventListener(
      'click',
      (event) => {
        if (closing.has(root) && event.isTrusted === false) return;
        const target = closeTarget(event);
        if (!target || !root.querySelector(CARD_SELECTOR)) return;
        event.preventDefault();
        event.stopPropagation();
        if (closing.has(root)) return;
        closing.add(root);
        animateOut(root).then(() => {
          target.click();
          closing.delete(root);
        });
      },
      true
    );
  }

  function scan(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(HOST_SELECTOR)) bind(node);
    node.querySelectorAll(HOST_SELECTOR).forEach(bind);
  }

  scan(document.documentElement);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(scan));
  }).observe(document.documentElement, { childList: true, subtree: true });
  ['form-embed', 'shopify-forms-embed'].forEach((tag) => {
    customElements.whenDefined(tag).then(() => scan(document.documentElement));
  });
})();
